import React from 'react';

type LogoProps = {
    alt: string
}

export const Logo = ({alt}: LogoProps) => <aside>
    <div>
        <img className="mx-auto h-12 w-auto" src={require('./ameego_logo_light_72dpi.jpg')} alt={alt}/>
    </div>
</aside>
